import Popover from '../../Popover/Popover';
export const PopoverCommonProps = {
    appendTo: Popover.propTypes['appendTo'],
    flip: Popover.propTypes['flip'],
    fixed: Popover.propTypes['fixed'],
    placement: Popover.propTypes['placement'],
    timeout: Popover.propTypes['timeout'],
    zIndex: Popover.propTypes['zIndex'],
    onMouseEnter: Popover.propTypes['onMouseEnter'],
    onMouseLeave: Popover.propTypes['onMouseLeave'],
    moveArrowTo: Popover.propTypes['moveArrowTo'],
    moveBy: Popover.propTypes['moveBy'],
    hideDelay: Popover.propTypes['hideDelay'],
    showDelay: Popover.propTypes['showDelay'],
    width: Popover.propTypes['width'],
    maxWidth: Popover.propTypes['maxWidth'],
    minWidth: Popover.propTypes['minWidth'],
    dynamicWidth: Popover.propTypes['dynamicWidth'],
};
//# sourceMappingURL=PopoverCommon.js.map